import React, { useEffect } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

const SuccessionDisclaimer = ({ query, updateCfaQuery, currentUser }) => {
  const intl = useIntl();
  const validate = () => {
    updateCfaQuery({ ...query, valid: true });
  };

  useEffect(() => {
    validate();
  }, []);

  return (
    <div className="max-w-2xl mx-auto">
      <h2 className="text-2xl font-bold text-gray-900 mb-6">
        <FormattedMessage id="calculators.cfa.tool_disclaimer"/>
      </h2>
      
      <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-6 mb-6">
        <p className="text-gray-700 leading-relaxed">
          {intl.formatMessage({ id: 'succession.cash_flow_analysis.disclaimer.paragraph_1' })}
        </p>
        <br />
        <p className="text-gray-700 leading-relaxed">
          {intl.formatMessage({ id: 'succession.cash_flow_analysis.disclaimer.paragraph_2' })}
        </p>
      </div>
      
      <div className="text-center">
        <p className="text-gray-600 mb-4">
          {intl.formatMessage({ id: 'succession.cash_flow_analysis.disclaimer.generate_instruction' })}
        </p>
      </div>
    </div>
  );
};

export default SuccessionDisclaimer; 